/* eslint-disable jsx-a11y/role-supports-aria-props */
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { checkPassword } from "../../utils/commonFunctions";
import PasswordValidator from "../PasswordValidator";
import { RecomendationPassword } from "../RecomendationPassword";
import "./index.scss";

const FieldRules = styled.div`
  .field-rules-enter {
    opacity: 0.01;
    transform: scale(0.9) translateY(50%);
  }
  .field-rules-enter-active {
    opacity: 1;
    transform: scale(1) translateY(0%);
    transition: all 600ms ease-out;
  }
  .field-rules-exit {
    opacity: 1;
    transform: scale(1) translateY(0%);
  }
  .field-rules-exit-active {
    opacity: 0.01;
    transform: scale(0.9) translateY(50%);
    transition: all 600ms ease-out;
  }
`;

const PasswordChecks = ({
  userid,
  password,
  firstName,
  lastName,
  emailAddress,
  validationMessage,
  checkIsValidPassword,
  gaOktaEnabled
}) => {
  const isValidPassword = checkPassword(
    userid,
    password,
    firstName,
    lastName,
    emailAddress,
    gaOktaEnabled,
  );
  checkIsValidPassword(isValidPassword);
  return (
    <div className="mb-5">
      <FieldRules>
        <CSSTransition
          in={!isValidPassword}
          timeout={600}
          classNames="field-rules"
          unmountOnExit
        >
          <div>
            <TransitionGroup>
              <CSSTransition
                key={!!password.length}
                timeout={600}
                classNames="field-rules"
                unmountOnExit
              >
                {password.length ? (
                  <>
                    {password.replace(/\s/g, '').length !== 0 && (
                      <p
                        aria-live="polite"
                        id="validation-error-message"
                        className="form-validation-error___2YuJL"
                      >
                        <span className="validation-icon___3zpVI">
                          <span className="icon___66GYG icon-sm___3uA1E icon-Inherit___1UF-f ">
                            <svg
                              viewBox="0 0 512 512"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              fill="currentColor"
                              role="none"
                              focusable="false"
                              aria-hidden="true"
                            >
                              <path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346 7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
                            </svg>
                          </span>
                        </span>
                        <span className="validation-text___H1nk9">
                          {validationMessage}
                        </span>
                      </p>
                    )}
                    <PasswordValidator
                      password={password}
                      user={userid}
                      firstName={firstName}
                      lastName={lastName}
                      emailAddress={emailAddress}
                      passwordComponentType="member"
                      gaOktaEnabled={gaOktaEnabled}
                    />
                  </>
                ) : (
                  <RecomendationPassword />
                )}
              </CSSTransition>
            </TransitionGroup>
          </div>
        </CSSTransition>
      </FieldRules>
    </div>
  );
};

PasswordChecks.propTypes = {
  userid: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  emailAddress: PropTypes.string,
  password: PropTypes.string,
  gaOktaEnabled: PropTypes.string,
};

PasswordChecks.defaultProps = {};

export default PasswordChecks;
